// extracted by mini-css-extract-plugin
export var arrow = "_l5-1";
export var content = "_l5-0";
export var highlighted = "_l5-2";